import React from 'react';

import { TableCell, TableHead, TableRow } from '@material-ui/core';

export function DeviceCategoryHeader() {
  return (
    <TableHead>
      <TableRow>
        <TableCell style={{ width: 210 }}>
          <strong>Category</strong>
        </TableCell>
        <TableCell style={{ width: 72 }}>
          <strong>Qty</strong>
        </TableCell>
        <TableCell style={{ width: 140 }}>
          <strong>Auto-generated</strong>
        </TableCell>
        <TableCell style={{ width: 120 }}>
          <strong>Pre-existing</strong>
        </TableCell>
        <TableCell style={{ minWidth: 120 }}>
          <strong>Serial Numbers</strong>
        </TableCell>
        <TableCell style={{ width: 48 }} />
        <TableCell style={{ width: 48 }} />
      </TableRow>
    </TableHead>
  );
}
